// extracted by css-extract-rspack-plugin
export default {"image-preview":"ImagePreview_image-preview__3kvBe","image-wrapper":"ImagePreview_image-wrapper__h-76N"};